/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Phase_Note_Block_EndInputs */

const en_us2_plan_phase_note_block_end = /** @type {(inputs: Plan_Phase_Note_Block_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last week of the cycle: this week's workouts come with fewer sets at the same weight. That's the deload, and it's planned. Normal volume comes back the week after.`)
};

const pt_br2_plan_phase_note_block_end = /** @type {(inputs: Plan_Phase_Note_Block_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última semana do ciclo: os treinos desta semana vêm com menos séries, com a mesma carga. É o deload, planejado, e o volume normal volta na semana seguinte.`)
};

const es_419_plan_phase_note_block_end = /** @type {(inputs: Plan_Phase_Note_Block_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última semana del ciclo: los entrenamientos de esta semana vienen con menos series y el mismo peso. Es la descarga, y está planeada. El volumen normal vuelve la semana siguiente.`)
};

const pt_pt2_plan_phase_note_block_end = /** @type {(inputs: Plan_Phase_Note_Block_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última semana do ciclo: os treinos desta semana trazem menos séries, com a mesma carga. É o deload, planeado, e o volume normal volta na semana seguinte.`)
};

const fr_fr2_plan_phase_note_block_end = /** @type {(inputs: Plan_Phase_Note_Block_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière semaine du cycle : les séances de cette semaine ont moins de séries, à la même charge. C'est la décharge, et elle est prévue. Le volume normal revient la semaine suivante.`)
};

const de_de2_plan_phase_note_block_end = /** @type {(inputs: Plan_Phase_Note_Block_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte Woche des Zyklus: Die Trainings dieser Woche haben weniger Sätze bei gleichem Gewicht. Das ist der Deload, und er ist geplant. In der Woche danach kommt das normale Volumen zurück.`)
};

const it_it2_plan_phase_note_block_end = /** @type {(inputs: Plan_Phase_Note_Block_EndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima settimana del ciclo: gli allenamenti di questa settimana hanno meno serie con lo stesso carico. È lo scarico, ed è previsto. Il volume normale torna la settimana dopo.`)
};

/**
* | output |
* | --- |
* | "Last week of the cycle: this week's workouts come with fewer sets at the same weight. That's the deload, and it's planned. Normal volume comes back the week ..." |
*
* @param {Plan_Phase_Note_Block_EndInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_phase_note_block_end = /** @type {((inputs?: Plan_Phase_Note_Block_EndInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Phase_Note_Block_EndInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_phase_note_block_end(inputs)
	if (locale === "es-419") return es_419_plan_phase_note_block_end(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_phase_note_block_end(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_phase_note_block_end(inputs)
	if (locale === "de-DE") return de_de2_plan_phase_note_block_end(inputs)
	if (locale === "it-IT") return it_it2_plan_phase_note_block_end(inputs)
	return en_us2_plan_phase_note_block_end(inputs)
});
export { plan_phase_note_block_end as "plan.phase_note.block_end" }